import React from 'react';

const PatientWorkflowContext = React.createContext({
  patient: null,
  organization: null
});

export default PatientWorkflowContext;
